import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Estado inicial del store. Se reutiliza en `reset()` para garantizar que no
 * queden campos desincronizados al agregar nuevas propiedades en el futuro.
 */
const initialState = {
  razonSocial: null,
  cuit: null,
  contratoId: null,
  contratos: [],
  contratoSelected: null,
  isAdmin: false,
}

export const useContratoStore = create(
  persist(
    (set) => ({
      ...initialState,

      setContratoData: ({ razonSocial, cuit, contratoId }) => set({ razonSocial, cuit, contratoId }),

      setContratos: (contratos) => set({ contratos }),

      setContratoSelected: (contratoSelected) => set({ contratoSelected }),

      setIsAdmin: (isAdmin) => set({ isAdmin }),

      clearContrato: () => set({ razonSocial: null, cuit: null, contratoId: null }),

      clearContratos: () => set({ contratos: [] }),

      clearContratoSelected: () => set({ contratoSelected: null }),

      /**
       * Restablece TODO el store (incluyendo `contratoId` e `isAdmin`) a sus
       * valores iniciales.
       *
       * Este store se persiste en `localStorage` (clave `contrato-storage`)
       * para sobrevivir recargas de página. Sin embargo, al cerrar sesión ese
       * valor persistido quedaba en el navegador: si otro usuario iniciaba
       * sesión en el mismo navegador, `configContratoUser` (en
       * `inicio.page.jsx`) encontraba un `contratoId` ya presente y
       * cortocircuitaba el flujo sin llamar a `/v2/usuario/me`, dejando al
       * nuevo usuario con los datos de contrato del usuario anterior.
       *
       * `reset()` debe invocarse siempre al cerrar sesión para evitar esta
       * fuga de datos entre usuarios que comparten navegador.
       */
      reset: () => set({ ...initialState }),
    }),
    {
      name: 'contrato-storage', // clave en localStorage
    }
  )
)
